module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "info"
    }
  }, [_c('article', [_c('h5', [_vm._v("About Mozzarella")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, consectetur. Do re eiusmod tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, consectetur.")]), _vm._v(" "), _c('ul', {
    staticClass: "c-info"
  }, [_c('li', [_vm._v("Fake street 123 - Springfield, USA")]), _vm._v(" "), _c('li', [_vm._v("inquiries@mozzarellabar.com")]), _vm._v(" "), _c('li', [_vm._v("(+044) 555 - 123 - 1234 / 35")])])]), _vm._v(" "), _c('article', {
    staticClass: "side-posts latests"
  }, [_c('h5', [_vm._v("Our Latests Posts")]), _vm._v(" "), _c('article', [_c('div', {
    staticClass: "circle small"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/blog/blog_image.png",
      "alt": "post"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon-small.png",
      "alt": "plus-icon-small"
    }
  })])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_vm._v("Touring Through The City")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])]), _vm._v(" "), _c('article', [_c('div', {
    staticClass: "circle small"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/blog/blog_image.png",
      "alt": "post"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon-small.png",
      "alt": "plus-icon-small"
    }
  })])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_vm._v("10 Easy Red Onion Recipes")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])]), _vm._v(" "), _c('article', [_c('div', {
    staticClass: "circle small"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/blog/blog_image.png",
      "alt": "post"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon-small.png",
      "alt": "plus-icon-small"
    }
  })])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_vm._v("Healthy Tea Benefits")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])])]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Flickr Widget")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "flickr-w"
    }
  })]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Opening Hours")]), _vm._v(" "), _c('article', {
    staticClass: "op-hours"
  }, [_c('div', [_c('h6', [_vm._v("Monday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Tuesday")]), _vm._v(" "), _c('h6', [_c('span', [_vm._v("Closed")])])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Wednesday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Thursday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Friday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Saturday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Sunday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "copy"
    }
  }, [_c('h5', [_c('span', [_vm._v("© 2019 Stanel World |")]), _vm._v(" All Rights Reserved")]), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Places")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Events")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0c39ee"}!./src/pages/MainFooter/template.html
// module id = 237
// module chunks = 0